import React from 'react'
import { useState } from 'react';
import Navbar from './components/Navbar'
import Home from './components/Home'
import Plans from './components/Plans'
import Services from './components/Servie'
import Support from './components/Support'
import WhatsApp from './components/WhatsApp'
import Contact from './components/Contact'
import Footer from './components/Footer'
const App = () => {
  const [connection, setConnection] = useState(false);
  return (
    <div>
      <Navbar connection={connection} setConnection={setConnection}/>
      <Home />
      <Plans connection={connection} setConnection={setConnection}/>
      <Services/>
      <Support/>
      <WhatsApp/>
      <Contact/>
      <Footer/>
    </div>
  )
}

export default App